import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';


const Loader = (props) => {
    const { open } = props;
    return (

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
        >
            <CircularProgress />
        </Backdrop>
    );

}

export default Loader;